module.exports = __webpack_public_path__ + "assets/media/about-l-phone.1487a27b.jpg";